module.exports = __webpack_public_path__ + "img/z (1).67aef3e6.png";